var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.current},[_c('Menu'),(this.$route.name !== 'home')?_c('info-box'):_vm._e(),_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm.credits[this.current]))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }